

export const Config = {
    server: process.env.REACT_APP_API_URL
}